/**
 * Featured collection – Load more
 * Lädt weitere Produktseiten der Section per Section Rendering API nach
 * und hängt die Karten ans bestehende Grid an.
 */
(function () {
  "use strict";

  var selectors = {
    section: "[data-fc-load-more]",
    grid: "[data-fc-load-more-grid]",
    actions: "[data-fc-load-more-actions]",
    button: "[data-fc-load-more-button]",
  };

  var loadingLabel = "Wird geladen …";

  function loadMore(section, button) {
    if (button.disabled) {
      return;
    }

    var grid = section.querySelector(selectors.grid);
    var currentActions = button.closest(selectors.actions);

    if (!grid || !currentActions) {
      return;
    }

    var sectionId = button.getAttribute("data-section-id");
    var pageParam = button.getAttribute("data-page-param") || "page";
    var nextPage = button.getAttribute("data-next-page");
    var originalLabel = button.textContent;
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    var url =
      root +
      "?section_id=" +
      encodeURIComponent(sectionId) +
      "&" +
      encodeURIComponent(pageParam) +
      "=" +
      encodeURIComponent(nextPage);

    button.disabled = true;
    button.textContent = loadingLabel;

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP " + response.status + " für " + url);
        }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newGrid = doc.querySelector(selectors.grid);

        if (!newGrid) {
          throw new Error("Kein Grid in der Antwort für " + url);
        }

        var newActions = newGrid.querySelector(selectors.actions);
        if (newActions) {
          newActions.remove();
        }

        var items = Array.prototype.slice.call(newGrid.children);
        if (!items.length) {
          throw new Error("Keine weiteren Produkte in der Antwort für " + url);
        }

        items.forEach(function (item) {
          grid.insertBefore(item, currentActions);
        });

        if (newActions) {
          grid.replaceChild(newActions, currentActions);
        } else {
          currentActions.remove();
        }

        // Quick-Shop bindet seine Listener beim Init-Scan, nicht delegiert –
        // neue Karten brauchen die Theme-Re-Init-Routine. Sie ignoriert ihr
        // Argument und re-initialisiert global (Quick-Shop, AOS, SPR, Collapsibles).
        try {
          if (
            window.theme &&
            typeof theme.reinitProductGridItem === "function"
          ) {
            theme.reinitProductGridItem(section);
          }
        } catch (error) {
          console.error("[fc-load-more]", error);
        }
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = originalLabel;
        console.error("[fc-load-more]", error);
      });
  }

  function init() {
    document.querySelectorAll(selectors.section).forEach(function (section) {
      if (section.dataset.fcLoadMoreInit === "true") {
        return;
      }
      section.dataset.fcLoadMoreInit = "true";

      section.addEventListener("click", function (evt) {
        var button = evt.target.closest
          ? evt.target.closest(selectors.button)
          : null;
        if (button) {
          loadMore(section, button);
        }
      });
    });
  }

  init();

  // Theme-Editor rendert Sections neu, ohne dass Page-Load-Skripte erneut laufen.
  // Das Script steckt im Section-Markup, läuft also pro Instanz einmal – Listener nur einmal binden.
  if (!window.fcLoadMoreEditorBound) {
    window.fcLoadMoreEditorBound = true;
    document.addEventListener("shopify:section:load", init);
  }
})();
